<template>
  <div
    v-if="shouldDisplayNotice"
    class="flex flex-col gap-2 p-4 rounded-md bg-gradient-radial bg-gradient-right-bottom from-primary to-secondary text-white-smoke"
  >
    <div class="font-medium uppercase">
      <FontAwesomeIcon :icon="faEarthEurope" />
      Notice RGPD
    </div>
    <p class="text-sm">
      Skyloud collecte vos données pour traiter votre demande et répondre à vos questions. En remplissant vos informations, vous acceptez que Skyloud traite vos données pour vous
      apporter une réponse. Pour plus d’informations sur la façon dont nous traitons vos données personnelles et l’exercice de vos droits, veuillez consulter notre
      <a
        href="https://www.skyloud.fr/politique-de-confidentialite"
        rel="noopener noreferrer"
        class="underline"
        target="_blank"
      >
        politique de confidentialité
      </a>
    </p>
    <SkyButton
      size="small"
      color="white"
      variant="outline"
      class="bg-secondary"
      @click="acknowledgeRgpdNotice"
    >
      Fermer
    </SkyButton>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import SkyButton from '@/components/ui/buttons/SkyButton.vue';
import { faEarthEurope } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const shouldDisplayNotice = ref(false);

onMounted(() => (shouldDisplayNotice.value = !localStorage.getItem('skyloud_projects_rgpd_acknowledge')));

function acknowledgeRgpdNotice() {
  shouldDisplayNotice.value = false;
  localStorage.setItem('skyloud_projects_rgpd_acknowledge', 'true');
}
</script>
